import React from "react";

const ShapMobile1 = () => {
	return (
		<svg width={265} height={291} viewBox="0 0 265 291" fill="none">
			<g filter="url(#filter0_f_34_82)">
				<path
					d="M-10.6884 133.333C34.5067 153.319 87.3465 132.883 107.333 87.6885C127.319 42.4934 106.884 -10.3466 61.6883 -30.3329C16.4935 -50.3193 -36.3465 -29.8836 -56.3329 15.3115C-76.3193 60.5066 -55.8836 113.347 -10.6884 133.333Z"
					fill="url(#paint0_radial_34_82)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_34_82"
					x={-214}
					y={-188}
					width={479}
					height={479}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={75}
						result="effect1_foregroundBlur_34_82"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_34_82"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(199.116 161.036) rotate(-154.439) scale(413.516 375.501)"
				>
					<stop offset="0.34394" stopColor="#00EBFF" />
					<stop offset="0.619147" stopColor="#FF39B0" />
					<stop offset="0.974236" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default ShapMobile1;
